import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { MatTooltipModule } from '@angular/material/tooltip';
import { FontAwesomeModule } from '@fortawesome/angular-fontawesome';
import { UserAvatarComponent } from '@y42/user/shared/user-avatar';
import { TriggeredByTypeCellRendererComponent } from './triggered-by-type-cell-renderer.component';

@NgModule({
  imports: [CommonModule, FontAwesomeModule, MatTooltipModule, UserAvatarComponent],
  declarations: [TriggeredByTypeCellRendererComponent],
  exports: [TriggeredByTypeCellRendererComponent],
})
export class TriggeredByTypeCellRendererModule {}
